/**
 * ScopedSessionStore.tsx — 外部 SessionTree 注入 SessionStore 上下文
 *
 * 职责：
 *     让 AgentLoopView 在 workflow scoped 子树渲染时复用 Timeline 组件栈。
 *
 * 链路位置：
 *     AgentLoopView（tree prop）→ ScopedSessionStoreProvider。
 *
 * 当前裁剪范围：
 *     只读同步 tree prop；不接收 live applyEvent（由父 workflow store 驱动）。
 */
import { useEffect, useRef, type ReactNode } from 'react';

import { SessionStoreContext } from '../../core/context/SessionContext';
import { createSessionStore } from '../../core/store';
import type { SessionTree } from '../../types/tree';

export function ScopedSessionStoreProvider({
  tree,
  children,
}: {
  tree: SessionTree;
  children: ReactNode;
}) {
  const storeRef = useRef(createSessionStore(tree, { initialEventCount: 1 }));
  useEffect(() => {
    storeRef.current.setState({ tree });
  }, [tree]);

  return (
    <SessionStoreContext.Provider value={storeRef.current}>
      {children}
    </SessionStoreContext.Provider>
  );
}
